module.exports = __webpack_public_path__ + "static/menu_admin-d1d839edba779e72283de11152a32f81.png";